import React from 'react'
import { FaInstagram, FaLinkedin, FaTwitter } from 'react-icons/fa'

function footer() {
  return (
    <div className='relative py-16 px-4 flex flex-col items-center justify-center overflow-hidden'>
      {/* Gradient Background */}
      <div className='absolute inset-0 bg-gradient-to-t from-purple-900/20 via-black to-transparent'></div>
      
      <div className='relative z-10 flex flex-col items-center'>
        <h1 className='text-4xl md:text-5xl lg:text-6xl font-bold mb-6 gradient-text'>
          Anmol Gaur
        </h1>
        
        <div className='flex gap-6 mt-4'>
          <a 
            href="https://www.instagram.com/anmol____gaur/" 
            target="_blank" 
            rel="noopener noreferrer"
            className='group'
          >
            <div className='p-4 rounded-full bg-white/5 border border-white/10 hover:bg-white/10 hover:border-accent-pink hover:shadow-glow transition-all duration-300 hover:scale-110'>
              <FaInstagram className='text-3xl text-white group-hover:text-accent-pink transition-colors duration-300'/>
            </div>
          </a>
          
          <a 
            href="https://www.linkedin.com/in/anmol-gaur-79963222b/" 
            target="_blank" 
            rel="noopener noreferrer"
            className='group'
          >
            <div className='p-4 rounded-full bg-white/5 border border-white/10 hover:bg-white/10 hover:border-accent-cyan hover:shadow-glow transition-all duration-300 hover:scale-110'>
              <FaLinkedin className='text-3xl text-white group-hover:text-accent-cyan transition-colors duration-300'/>
            </div>
          </a>
          
          <a 
            href="https://twitter.com/AnmolGaur26" 
            target="_blank" 
            rel="noopener noreferrer"
            className='group'
          >
            <div className='p-4 rounded-full bg-white/5 border border-white/10 hover:bg-white/10 hover:border-accent-purple hover:shadow-glow transition-all duration-300 hover:scale-110'>
              <FaTwitter className='text-3xl text-white group-hover:text-accent-purple transition-colors duration-300'/>
            </div>
          </a>
        </div>
      </div>
    </div>
  )
}

export default footer
